import { EventName } from '../../services/EventTrackingService';

export interface HelpCopyProps {
  text: string;
  ctaText: string;
  href: string;
  trackingEvent?:
    | EventName.HelpClickAdditionalLanguages
    | EventName.HelpClickBetaProject
    | EventName.HelpClickCues
    | EventName.HelpClickLibraryReplacements;
}

export const CUES_HELP_COPY: HelpCopyProps = {
  text: 'Need help with Cues?',
  ctaText: 'Help Center',
  href: `https://help.wellsaid.io/hc/en-us/articles/39185803987347-Guide-to-Voice-Cues`,
  trackingEvent: EventName.HelpClickCues,
};

export const REPLACEMENT_LIBRARY_COPY: HelpCopyProps = {
  text: 'Need help with Replacements?',
  ctaText: 'Help Center',
  href: `https://help.wellsaid.io/hc/en-us/articles/39187426777363-Guide-to-Replacements`,
  trackingEvent: EventName.HelpClickLibraryReplacements,
};

export const RESPELLING_TOGGLE_COPY: HelpCopyProps = {
  text: 'What is this? Guide to',
  ctaText: 'Respellings',
  href: `https://help.wellsaid.io/hc/en-us/articles/39188339794451-Guide-to-Respellings`,
};
